import mapColors from './map-colors';
var grayCollection = [{
  key: 'white',
  color: '#fff'
}, {
  key: 'gray_100',
  color: '#f8f9fa'
}, {
  key: 'gray_200',
  color: '#e9ecef'
}, {
  key: 'gray_300',
  color: '#dee2e6'
}, {
  key: 'gray_400',
  color: '#ced4da'
}, {
  key: 'gray_500',
  color: '#adb5bd'
}, {
  key: 'gray_600',
  color: '#6c757d'
}, {
  key: 'gray_700',
  color: '#495057'
}, {
  key: 'gray_800',
  color: '#343a40'
}, {
  key: 'gray_900',
  color: '#212529'
}, {
  key: 'black',
  color: '#000'
}];
var grays = mapColors(grayCollection);
export default grays;
export { grayCollection };